/**
 * Query keys for the role-grant commission pre-flight.
 *
 * Lives in a `*Keys` file because `staleAfterSaveGate.test.ts` requires every
 * `queryKey: [` array literal to — and because `UsersPage.tsx` is already
 * EXACTLY AT its grandfathered inline-key baseline of 2, so an inline key added
 * there fails the gate rather than merely being untidy.
 */
export const roleGrantKeys = {
  all: ["role-grant-preflight"] as const,
  preflight: (roleCode: string) => ["role-grant-preflight", roleCode] as const,
};
